import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-stone-200 bg-white" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-14 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 font-extrabold text-xl text-stone-900 mb-3">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M12 3 L21 19 H3 Z M9 19 L12 13 L15 19 Z" fill="#0E1411" />
            </svg>
            WaterfallFinder
          </div>
          <p className="text-sm text-stone-600 max-w-sm leading-relaxed">
            The world&apos;s most trusted waterfall discovery guide. Photos, maps, trail stats and safety advice for every fall.
          </p>
        </div>
        <FooterCol title="Company" links={[
          { to: "/about", label: "About us" },
          { to: "/safety", label: "Safety" },
          { to: "/best-waterfalls", label: "Best Of" },
        ]} />
        <FooterCol title="Explore" links={[
          { to: "/best-waterfalls-in/country/united-states", label: "USA" },
          { to: "/best-waterfalls-in/country/australia", label: "Australia" },
          { to: "/best-waterfalls-in/country/united-kingdom", label: "UK" },
          { to: "/best-waterfalls-in/country/canada", label: "Canada" },
          { to: "/best-waterfalls-in/country/iceland", label: "Iceland" },
          { to: "/best-waterfalls-in/country/croatia", label: "Croatia" },
          { to: "/best-waterfalls-in/country/costa-rica", label: "Costa Rica" },
          { to: "/best-waterfalls-in/country/indonesia", label: "Indonesia" },
          { to: "/best-waterfalls-in/country/india", label: "India" },
          { to: "/best-waterfalls-in/country/switzerland", label: "Switzerland" },
        ]} />
        <FooterCol title="Resources" links={[
          { to: "/api/sitemap.xml", label: "Sitemap" },
        ]} external />
      </div>
      <div className="border-t border-stone-200">
        <p className="text-xs text-stone-500 text-center py-5">© {new Date().getFullYear()} WaterfallFinder · Stay safe out there.</p>
      </div>
    </footer>
  );
}

function FooterCol({ title, links, external }) {
  return (
    <div>
      <h4 className="text-sm font-bold text-stone-900 mb-3">{title}</h4>
      <ul className="space-y-2 text-sm">
        {links.map((l) =>
          external ? (
            <li key={l.to}>
              <a href={l.to} className="text-stone-600 hover:text-stone-900">
                {l.label}
              </a>
            </li>
          ) : (
            <li key={l.to}>
              <Link to={l.to} className="text-stone-600 hover:text-stone-900">
                {l.label}
              </Link>
            </li>
          )
        )}
      </ul>
    </div>
  );
}
